// extracted by mini-css-extract-plugin
module.exports = {"link":"Link_link__1s8J1","block":"Link_block__8uLBw"};